module.exports = __webpack_public_path__ + "static/img/image_we_08_01.c6a4e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_08_01.png
// module id = FNei
// module chunks = 10